import { proxy, ref } from 'valtio'
import { ZonePath } from '../interfaces/types.ts'
import { SafeZoneInstructions } from '../components/safeZones/components/Instructions.tsx'

export type SafeZoneControlViewType = 'list' | 'choose' | 'drawing' | 'search' | 'finish'

export const safeZoneState = proxy({
    safeZonePolygons: [] as React.ReactElement[],
    newSafeZone: null as React.ReactElement | null,
    newSafeZoneGeometry: [] as ZonePath,
    editedZoneName: '',
    editedSafeZoneGeometry: [] as ZonePath,
    safeZoneBeingEdited: '',
    updatedZonePath: [] as ZonePath,
    active: false,
    view: 'list' as SafeZoneControlViewType,
    instructions: null as SafeZoneInstructions | null,
    drawingManager: null as any,
})

// --- Action functions for values needing ref() ---

export function setSafeZonePolygons(polygons: React.ReactElement[]) {
    safeZoneState.safeZonePolygons = ref(polygons) as any
}

export function setNewSafeZone(el: React.ReactElement | null) {
    safeZoneState.newSafeZone = el ? (ref(el) as any) : null
}

export function resetSafeZone() {
    safeZoneState.safeZonePolygons = []
    safeZoneState.newSafeZone = null
    safeZoneState.editedZoneName = ''
    safeZoneState.safeZoneBeingEdited = ''
    safeZoneState.updatedZonePath = []
    safeZoneState.view = 'list'
    safeZoneState.active = false
    safeZoneState.instructions = null
    safeZoneState.drawingManager = null
}

export default safeZoneState
